import { H3 } from './LegacyTypography';
import { FCC } from './types';

export const PageSubtitle: FCC<{ className?: string }> = ({ children }) => {
  return <H3 p="pb-2">{children}</H3>;
};
